export const ScrollAlignment = {
  NEAREST: 'nearest',
  START: 'start',
  CENTER: 'center',
  END: 'end',
} as const;

export type ScrollAlignmentType = (typeof ScrollAlignment)[keyof typeof ScrollAlignment];

const alignmentProperty = {
  type: 'string',
  default: ScrollAlignment.NEAREST,
  oneOf: [
    {
      const: ScrollAlignment.NEAREST,
      title: 'Nearest',
    },
    {
      const: ScrollAlignment.START,
      title: 'Start',
    },
    {
      const: ScrollAlignment.CENTER,
      title: 'Center',
    },
    {
      const: ScrollAlignment.END,
      title: 'End',
    },
  ],
};

const smoothProperty = {
  type: 'boolean',
  default: true,
};

const alignmentUISchema = {
  'ui:widget': 'VariableSelectWidget',
  'ui:title': 'Alignment',
  'ui:description':
    'Nearest: Scrolls only the minimum amount required for the component to appear in the visible area. Scrolling does not occur if the component is already in view.\n\nStart: Scrolls to position the component at the top of the visible area.\n\nCenter: Scrolls to position the component in the middle of the visible area.\n\nEnd: Scrolls to position the component at the bottom of the visible area.',
};

const smoothUISchema = {
  'ui:widget': 'ToggleWidget',
  'ui:fieldLayout': [['title', 'children']],
  'ui:childrenClassName': '',
  'ui:title': 'Smooth Scroll',
  'ui:description': 'Enable smooth scrolling animation. When false, scrolling happens instantly.',
};

const scrollIntoViewSchema = {
  type: 'object',
  properties: {
    methodPayload: {
      type: 'object',
      properties: {
        alignment: alignmentProperty,
        smooth: smoothProperty,
      },
    },
  },
};

const scrollIntoViewUISchema = {
  methodPayload: {
    'ui:title': false,
    'ua:collapsible': false,
    'ua:disableBackground': true,
    alignment: alignmentUISchema,
    smooth: smoothUISchema,
  },
};

export const getMethodSchema = ({ methodName }: { methodName: string }) => {
  switch (methodName) {
    case 'scrollIntoView':
      return { schema: scrollIntoViewSchema, uiSchema: scrollIntoViewUISchema };
    default:
      return { schema: {}, uiSchema: {} };
  }
};
